module.exports = __webpack_public_path__ + "static/media/fish-cooked.fc0e8381.svg";